import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { env } from '@amfam/environment';

import { PaymentRecordRequest, PaymentRecordResponse } from '../models/payment-capture.model';

@Injectable({
  providedIn: 'root'
})
export class PaymentaccountService {
  private http = inject(HttpClient);

  public updateScreenRecording(payload: PaymentRecordRequest): Observable<PaymentRecordResponse> {
    const recordUri = env.i3ExpApi + 'securePause';
    return this.http.post<PaymentRecordResponse>(recordUri, {
      userID: payload.userID,
      action: payload.operation
    });
  }
}
